'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isUngatedSelector = exports.isUngatedSelector = function isUngatedSelector(state, gateKey) {
  var gates = state.auth.gates;

  return gates && gates.indexOf(gateKey) !== -1;
};

var gatesSelector = exports.gatesSelector = function gatesSelector(state) {
  return state.auth.gates;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/GatingSelectors.js
// module id = 765
// module chunks = 3 4